export default {
    data: function () {
        return {
            params: this.initParams(),
            errors: {},
            stats: null,
            periode: '',
            optionsPeriode: [
                {value: 'week', label: 'Hebdomadaire'},
                {value: 'month', label: 'Mensuel'}
            ],
            loading: false
        }
    },

    methods: {
        /**
         * Affiche une periode
         */
        displayPeriode: function (from) {
            let date = moment(from)
            let periode = this.periode === 'week' ? ('S' + date.week()) : ('M' + (date.month() + 1))
            return `${periode} ${date.year()}`
        },

        /**
         * Initialise les paramètres de recherche sur les stats
         */
        initParams: function () {
            return {
                periode: 'week',
                from: moment().subtract(10, 'weeks').format('YYYY-MM-DD'),
                to: moment().format('YYYY-MM-DD'),
                // Pour l'année fiscale (en juin il faut que ça bascule à l'année suivante)
                exercice: moment().subtract(5, 'months').year(),
                commercial: [],
            }
        },

        /**
         * Réinitialise les paramètres
         */
        reinit: function () {
            this.params = this.initParams()
        },

        /**
         * @return String
         */
        now: function () {
            return moment().format('YYYY-MM-DD')
        }
    },
}
